var _path, _path2, _path3, _path4, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _g, _g2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEnvelopeTemplate = function SvgEnvelopeTemplate(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160.0mm",
    height: "262.5mm",
    viewBox: "0.0 -20.5 160.0 262.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.2,
    d: "M 23 32 Q 21 32 21 30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.2,
    d: "M 23 20 Q 21 20 21 22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.2,
    d: "M 117 32 Q 119 32 119 30"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.2,
    d: "M 117 20 Q 119 20 119 22"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    x2: 120,
    y1: 47,
    y2: 47,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 120,
    x2: 120,
    y1: 47,
    y2: 147,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    x2: 120,
    y1: 147,
    y2: 147,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    x2: 20,
    y1: 47,
    y2: 147,
    stroke: "red",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    x2: 0,
    y1: 47,
    y2: 67,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 67,
    y2: 127,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 20,
    y1: 127,
    y2: 147,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 120,
    x2: 140,
    y1: 47,
    y2: 67,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 140,
    x2: 140,
    y1: 67,
    y2: 127,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 120,
    x2: 140,
    y1: 147,
    y2: 127,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 26.4,
    x2: 20,
    y1: 31.9,
    y2: 47,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 23,
    x2: 31.4,
    y1: 32,
    y2: 32,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    x2: 21,
    y1: 22,
    y2: 30,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 23,
    x2: 36.6,
    y1: 20,
    y2: 20,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 31.599999999999998,
    x2: 40,
    y1: 19.9,
    y2: 0,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 113.6,
    x2: 120,
    y1: 31.9,
    y2: 47,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 108.6,
    x2: 117,
    y1: 32,
    y2: 32,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 119,
    x2: 119,
    y1: 22,
    y2: 30,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 103.39999999999999,
    x2: 117,
    y1: 20,
    y2: 20,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 108.39999999999999,
    x2: 100,
    y1: 19.9,
    y2: 0,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    x2: 100,
    y1: 0,
    y2: 0,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    x2: 21,
    y1: 147,
    y2: 149,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    x2: 21,
    y1: 149,
    y2: 242,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    x2: 119,
    y1: 242,
    y2: 242,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 119,
    x2: 119,
    y1: 149,
    y2: 242,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 120,
    x2: 119,
    y1: 147,
    y2: 149,
    stroke: "black",
    strokeLinecap: "round",
    strokeWidth: 0.2
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: -15,
    y2: 67,
    stroke: "black",
    strokeDasharray: "2 7 10 12",
    strokeWidth: 0.05
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    x2: 155,
    y1: 242,
    y2: 242,
    stroke: "black",
    strokeDasharray: "2 7 10 12",
    strokeWidth: 0.05
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "width"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 20.196627,
    x2: 120.19662,
    y1: 54.910408,
    y2: 54.910408,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.19662,
    x2: 116.19662,
    y1: 54.910408,
    y2: 53.910408,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.19662,
    x2: 116.19662,
    y1: 54.910408,
    y2: 55.910408,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.196627,
    x2: 24.196627,
    y1: 54.910408,
    y2: 53.910408,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.196627,
    x2: 24.196627,
    y1: 54.910408,
    y2: 55.910408,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 68.904572,
    y: 53.107033,
    fill: "#000",
    strokeWidth: 0.05,
    fontSize: "4px",
    textAnchor: "middle"
  }, "\n            Width\n        "))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "height"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 110.72626,
    x2: 110.72626,
    y1: 46.803375,
    y2: 146.80338,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110.72626,
    x2: 109.72626,
    y1: 46.803375,
    y2: 50.803375,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110.72626,
    x2: 111.72626,
    y1: 46.803375,
    y2: 50.803375,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110.72626,
    x2: 109.72626,
    y1: 146.80338,
    y2: 142.80338,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110.72626,
    x2: 111.72626,
    y1: 146.80338,
    y2: 142.80338,
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: -98.803375,
    y: 115.72626,
    fill: "#000",
    fontSize: "4px",
    textAnchor: "middle",
    transform: "rotate(-90)"
  }, "\n            Height\n        "))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEnvelopeTemplate, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/envelope-template.995aaa4c.svg";
export { ForwardRef as ReactComponent };